(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["seen-it-cheaper-banner"] && !Shopify.designMode) return;
  try {
    // Reuse the support widget's contact action, including its validation and focus handling.
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-pa-product-contact]');
  if (!link) return;
  const contact = document.querySelector('.pa-sw-root [data-action="contact"]');
  if (!contact) return;
  event.preventDefault();
  contact.click();
});
  } catch(e) { console.error(e); }
})();

})();
